import { Area } from './Area';
import { AreaProps } from './types';

type Props<T> = Omit<
  AreaProps<T>,
  | 'name'
  | 'variant'
  | 'fill'
  | 'fillOpacity'
  | 'isAnimationActive'
  | 'dot'
  | 'activeDot'
>;

export const InvisibleArea = <T,>(props: Props<T>) => {
  return (
    <Area
      {...props}
      tooltipConfig={{
        hidden: true,
      }}
      variant="filled"
      fill="none"
      fillOpacity={0}
      isAnimationActive={false}
      dot={false}
      activeDot={false}
    />
  );
};
